import { render, staticRenderFns } from "./IconTime.vue?vue&type=template&id=15058459&scoped=true&"
import script from "./IconTime.vue?vue&type=script&lang=ts&"
export * from "./IconTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15058459",
  null
  
)

export default component.exports